var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1329 0C16.0454 0 19.3124 2.98343 19.6666 6.87988L20.2091 12.8477C20.2568 13.3716 20.5721 13.8335 21.0426 14.0688L21.0468 14.0709C22.1003 14.5977 22.7658 15.6744 22.7658 16.8523V17.3165C22.7658 18.8265 21.5417 20.0506 20.0316 20.0506H15.4746V20.6582C15.4746 22.5038 13.9784 24 12.1328 24C10.2872 24 8.79107 22.5038 8.79107 20.6582V20.0506H4.23418C2.72413 20.0506 1.5 18.8265 1.5 17.3165V16.8523C1.5 15.6744 2.16548 14.5977 3.219 14.0709L3.22326 14.0688C3.69377 13.8335 4.00907 13.3716 4.0567 12.8477L4.59922 6.87988C4.95344 2.98343 8.2204 0 12.1329 0ZM10.6138 20.0506V20.6582C10.6138 21.4972 11.2939 22.1772 12.1328 22.1772C12.9718 22.1772 13.6518 21.4972 13.6518 20.6582V20.0506H10.6138ZM12.1334 1.823C9.1636 1.823 6.68385 4.08755 6.41498 7.04512L5.87245 13.0129C5.76767 14.1655 5.07402 15.1818 4.03889 15.6993C3.59864 15.9195 3.32324 16.3651 3.32324 16.8525V17.3167C3.32324 17.82 3.73129 18.2281 4.23463 18.2281H20.0321C20.5355 18.2281 20.9435 17.82 20.9435 17.3167V16.8525C20.9435 16.3651 20.6681 15.9195 20.2321 15.7015C19.1927 15.1818 18.4991 14.1655 18.3943 13.0129L17.8518 7.04512C17.5829 4.08755 15.1031 1.823 12.1334 1.823Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.674e8a691ab71add44b2550098f81b0b.svg";
export { ForwardRef as ReactComponent };